// extracted by mini-css-extract-plugin
export var wordContainer = "_ru-0";